export const isLogoutAlertOpen = (state) => state.auth.showLogoutAlert;
export const invalidTokenSelector = (state) => state.auth.hasInvalidToken;
